import styled from "@emotion/styled";
import GalleryComponent from "../Gallery";

import { BasicFlex } from "../../Common";

import CloseIcon from '@mui/icons-material/CloseRounded';

import { IconButton } from "@mui/material";

const ImageDisplay = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.softBg};
  padding: 1rem;
  border-radius: 8px;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  margin-top: .5rem;
`

const ImageTile = styled.div`
  width: 20rem;
  height: 20rem;
  position: relative;
  background-color: #fff;
  border-radius: 3px;
`

const NameBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, .4);
  color: white;
  padding: .2rem .5rem;
`

const CloseButton = styled(BasicFlex)`
  position: absolute;
  top: 0;
  right: 0;
  /* background-color: rgba(0, 0, 0, .4);
  color: white;
  padding: .2rem .5rem; */
`

const ImageDisplayComponent = ({media_urls = [], onClick}) => {
  return (
    <ImageDisplay justify="flex-start">
      {media_urls.map(({key, originalname, label, thumbnail, signedUrlKey, signedUrl: url}, index) => (
        <GalleryComponent key={key} images={media_urls} imageIndex={index}
        fullScreen
        title={label}
          toggle={
          <ImageTile key={key}>
            <CloseButton justify="flex-end">
              <IconButton size="small" color="basic" onClick={() => onClick(index)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </CloseButton>
            <img 
              src={url}
              onError={(e) => {
                e.currentTarget.onerror = null; // prevent loop if fallback also fails
                e.currentTarget.src = signedUrlKey;
              }}
              style={{width: '100%', height: '100%', objectFit: 'cover'}} 
            />
            <NameBar>{label}</NameBar>
          </ImageTile>
          }
        />
        )
      )}
    </ImageDisplay>
  )
};

export default ImageDisplayComponent;